import React from "react";
import Image from "next/image";
import { Container, Row, Col } from "react-bootstrap";
import Logo from "../Logo/Logo";
import styles from "./Header.module.css";
import LeftDrawerMenu from "../DrawerMenu";
import MainMenu from "../MainMenu";
import { useEffect, useState } from "react";

function LandingHeader({ s3_front_end_image, deviceType }) {
  /////////////////
  const [screenWidth, setScreenWidth] = useState(0);
  const [isMyMobile, setIsMyMobile] = useState(false);

  useEffect(() => {
    setScreenWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    setIsMyMobile(screenWidth <= 1300);
  }, [screenWidth]);
  ///////////////////////////

  const [announcementH, setAnnouncementH] = useState(0);
const [headerH, setHeaderH] = useState(0);

useEffect(() => {
  const announcementBar = document.querySelector(".sticky_barmar");
  const header = document.querySelector("header.header");

  if (announcementBar && header) {
    setAnnouncementH(announcementBar.offsetHeight);
    setHeaderH(header.offsetHeight); // Set header height initially
  }

  const handleScroll = () => {
    if (announcementBar && header) {
      if (window.scrollY > announcementH) {
        header.classList.add("fixed");
        announcementBar.style.marginBottom = `${headerH}px`;
      } else {
        header.classList.remove("fixed");
        announcementBar.style.marginBottom = "0";
      }
    }
  };

  // Set initial margin
  if (announcementBar) {
    announcementBar.style.marginBottom = "0";
  }

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, [announcementH, headerH]);
////////////////////////////

  return (
    <>
      <header className="header border-bottom">
      {isMyMobile ? (
      <div className="sticky_bar py-2 d-flex align-items-center ">
          <marquee> Over 600,000 users | Featured in BBC, CNBC | PAN India Service </marquee> 
        </div>
      ) : (
        <div className="sticky_bar py-1">
        Over 600,000 users | Featured in BBC, CNBC | PAN India Service
        </div>
      )}
        <Container fluid>
          <div className="d-flex align-items-center justify-content-between py-2 gap-2">
            {isMyMobile && (
              <div className="mnutog">
                <LeftDrawerMenu pageLayout="landing" />
              </div>
            )}
            <div>
              <Logo />
            </div>
            {!isMyMobile && <MainMenu displayOn="landing" />}

            <div>
              <div>
                {deviceType === "mobile" ? (
                  <>
                    <a href={`tel:+91${process.env.NEXT_PUBLIC_CONTACT_NO}`}>
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 43 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="21.2695" cy="21" r="21" fill="#0474B4" />
                        <g clipPath="url(#clip0_11_577)">
                          <path
                            d="M26.9223 24.2691C26.5168 23.8469 26.0277 23.6212 25.5094 23.6212C24.9952 23.6212 24.5019 23.8427 24.0797 24.2649L22.7588 25.5817C22.6501 25.5232 22.5414 25.4688 22.4369 25.4145C22.2864 25.3392 22.1443 25.2682 22.0231 25.1929C20.7857 24.4071 19.6613 23.3829 18.5828 22.0578C18.0603 21.3973 17.7091 20.8414 17.4541 20.277C17.7969 19.9635 18.1146 19.6375 18.4239 19.324C18.541 19.2069 18.658 19.0857 18.7751 18.9686C19.6529 18.0908 19.6529 16.9538 18.7751 16.0759L17.6339 14.9348C17.5043 14.8052 17.3705 14.6714 17.2451 14.5376C16.9943 14.2785 16.731 14.0109 16.4592 13.7601C16.0538 13.3588 15.5689 13.1456 15.0589 13.1456C14.5489 13.1456 14.0556 13.3588 13.6376 13.7601C13.6334 13.7643 13.6334 13.7643 13.6293 13.7685L12.208 15.2023C11.6729 15.7373 11.3678 16.3895 11.3009 17.1461C11.2006 18.3667 11.5601 19.5037 11.836 20.2478C12.5131 22.0745 13.5248 23.7675 15.0338 25.5817C16.8647 27.7679 19.0677 29.4944 21.5842 30.7108C22.5456 31.1664 23.8289 31.7057 25.2627 31.7976C25.3505 31.8018 25.4425 31.806 25.5261 31.806C26.4917 31.806 27.3027 31.4591 27.9381 30.7693C27.9422 30.761 27.9506 30.7568 27.9548 30.7484C28.1721 30.4851 28.423 30.2468 28.6863 29.9918C28.8661 29.8204 29.05 29.6407 29.2297 29.4526C29.6436 29.022 29.8609 28.5204 29.8609 28.0062C29.8609 27.4879 29.6394 26.9904 29.2172 26.5724L26.9223 24.2691ZM28.4188 28.6709C28.4146 28.6709 28.4146 28.675 28.4188 28.6709C28.2557 28.8464 28.0885 29.0053 27.9088 29.1808C27.6371 29.44 27.3612 29.7117 27.102 30.0169C26.6798 30.4683 26.1824 30.6815 25.5303 30.6815C25.4676 30.6815 25.4007 30.6815 25.338 30.6774C24.0965 30.5979 22.9427 30.113 22.0774 29.6992C19.7114 28.5538 17.6339 26.9277 15.9075 24.8669C14.482 23.1488 13.5289 21.5604 12.8977 19.8548C12.509 18.814 12.3668 18.003 12.4295 17.238C12.4713 16.749 12.6595 16.3435 13.0064 15.9965L14.4319 14.5711C14.6367 14.3788 14.8541 14.2743 15.0672 14.2743C15.3306 14.2743 15.5438 14.4331 15.6776 14.5669C15.6817 14.5711 15.6859 14.5753 15.6901 14.5794C15.9451 14.8177 16.1875 15.0643 16.4425 15.3277C16.5721 15.4615 16.7059 15.5952 16.8396 15.7332L17.9808 16.8744C18.4239 17.3175 18.4239 17.7271 17.9808 18.1702C17.8596 18.2914 17.7426 18.4127 17.6213 18.5297C17.2702 18.8892 16.9358 19.2236 16.5721 19.5497C16.5638 19.558 16.5554 19.5622 16.5512 19.5706C16.1917 19.9301 16.2586 20.2812 16.3338 20.5195C16.338 20.532 16.3422 20.5446 16.3464 20.5571C16.6432 21.2761 17.0612 21.9533 17.6966 22.7601L17.7008 22.7643C18.8545 24.1855 20.0709 25.2933 21.4128 26.1418C21.5842 26.2505 21.7597 26.3383 21.9269 26.4219C22.0774 26.4972 22.2196 26.5682 22.3408 26.6435C22.3575 26.6518 22.3742 26.6644 22.3909 26.6727C22.5331 26.7438 22.6668 26.7772 22.8048 26.7772C23.1517 26.7772 23.3691 26.5599 23.4402 26.4888L24.8698 25.0592C25.0119 24.9171 25.2377 24.7457 25.501 24.7457C25.7602 24.7457 25.9734 24.9087 26.103 25.0508C26.1071 25.055 26.1071 25.055 26.1113 25.0592L28.4146 27.3625C28.8452 27.7888 28.8452 28.2278 28.4188 28.6709Z"
                            fill="white"
                          />
                          <path
                            d="M21.9728 16.7113C23.068 16.8953 24.0629 17.4136 24.8571 18.2078C25.6514 19.0021 26.1655 19.997 26.3537 21.0922C26.3996 21.3681 26.6379 21.5604 26.9096 21.5604C26.9431 21.5604 26.9723 21.5562 27.0058 21.552C27.3151 21.5018 27.5199 21.2092 27.4698 20.8999C27.244 19.5748 26.617 18.3667 25.6597 17.4094C24.7025 16.4522 23.4944 15.8251 22.1693 15.5994C21.8599 15.5492 21.5715 15.7541 21.5172 16.0592C21.4628 16.3644 21.6635 16.6612 21.9728 16.7113Z"
                            fill="white"
                          />
                          <path
                            d="M31.0522 20.7369C30.6801 18.5548 29.6518 16.5692 28.0717 14.9891C26.4916 13.409 24.506 12.3807 22.3239 12.0086C22.0188 11.9543 21.7304 12.1633 21.676 12.4684C21.6258 12.7778 21.8307 13.0662 22.14 13.1205C24.088 13.4508 25.8646 14.3746 27.2775 15.7833C28.6904 17.1962 29.61 18.9728 29.9402 20.9208C29.9862 21.1967 30.2245 21.389 30.4962 21.389C30.5297 21.389 30.5589 21.3848 30.5924 21.3806C30.8975 21.3346 31.1065 21.042 31.0522 20.7369Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_11_577">
                            <rect
                              width="19.806"
                              height="19.806"
                              fill="white"
                              transform="translate(11.2695 12)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </>
                ) : (
                  <>
                    <a href={`tel:+91${process.env.NEXT_PUBLIC_CONTACT_NO}`}>
                      <svg
                        width="42"
                        height="42"
                        viewBox="0 0 43 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="21.2695" cy="21" r="21" fill="#0474B4" />
                        <g clipPath="url(#clip0_11_577)">
                          <path
                            d="M26.9223 24.2691C26.5168 23.8469 26.0277 23.6212 25.5094 23.6212C24.9952 23.6212 24.5019 23.8427 24.0797 24.2649L22.7588 25.5817C22.6501 25.5232 22.5414 25.4688 22.4369 25.4145C22.2864 25.3392 22.1443 25.2682 22.0231 25.1929C20.7857 24.4071 19.6613 23.3829 18.5828 22.0578C18.0603 21.3973 17.7091 20.8414 17.4541 20.277C17.7969 19.9635 18.1146 19.6375 18.4239 19.324C18.541 19.2069 18.658 19.0857 18.7751 18.9686C19.6529 18.0908 19.6529 16.9538 18.7751 16.0759L17.6339 14.9348C17.5043 14.8052 17.3705 14.6714 17.2451 14.5376C16.9943 14.2785 16.731 14.0109 16.4592 13.7601C16.0538 13.3588 15.5689 13.1456 15.0589 13.1456C14.5489 13.1456 14.0556 13.3588 13.6376 13.7601C13.6334 13.7643 13.6334 13.7643 13.6293 13.7685L12.208 15.2023C11.6729 15.7373 11.3678 16.3895 11.3009 17.1461C11.2006 18.3667 11.5601 19.5037 11.836 20.2478C12.5131 22.0745 13.5248 23.7675 15.0338 25.5817C16.8647 27.7679 19.0677 29.4944 21.5842 30.7108C22.5456 31.1664 23.8289 31.7057 25.2627 31.7976C25.3505 31.8018 25.4425 31.806 25.5261 31.806C26.4917 31.806 27.3027 31.4591 27.9381 30.7693C27.9422 30.761 27.9506 30.7568 27.9548 30.7484C28.1721 30.4851 28.423 30.2468 28.6863 29.9918C28.8661 29.8204 29.05 29.6407 29.2297 29.4526C29.6436 29.022 29.8609 28.5204 29.8609 28.0062C29.8609 27.4879 29.6394 26.9904 29.2172 26.5724L26.9223 24.2691ZM28.4188 28.6709C28.4146 28.6709 28.4146 28.675 28.4188 28.6709C28.2557 28.8464 28.0885 29.0053 27.9088 29.1808C27.6371 29.44 27.3612 29.7117 27.102 30.0169C26.6798 30.4683 26.1824 30.6815 25.5303 30.6815C25.4676 30.6815 25.4007 30.6815 25.338 30.6774C24.0965 30.5979 22.9427 30.113 22.0774 29.6992C19.7114 28.5538 17.6339 26.9277 15.9075 24.8669C14.482 23.1488 13.5289 21.5604 12.8977 19.8548C12.509 18.814 12.3668 18.003 12.4295 17.238C12.4713 16.749 12.6595 16.3435 13.0064 15.9965L14.4319 14.5711C14.6367 14.3788 14.8541 14.2743 15.0672 14.2743C15.3306 14.2743 15.5438 14.4331 15.6776 14.5669C15.6817 14.5711 15.6859 14.5753 15.6901 14.5794C15.9451 14.8177 16.1875 15.0643 16.4425 15.3277C16.5721 15.4615 16.7059 15.5952 16.8396 15.7332L17.9808 16.8744C18.4239 17.3175 18.4239 17.7271 17.9808 18.1702C17.8596 18.2914 17.7426 18.4127 17.6213 18.5297C17.2702 18.8892 16.9358 19.2236 16.5721 19.5497C16.5638 19.558 16.5554 19.5622 16.5512 19.5706C16.1917 19.9301 16.2586 20.2812 16.3338 20.5195C16.338 20.532 16.3422 20.5446 16.3464 20.5571C16.6432 21.2761 17.0612 21.9533 17.6966 22.7601L17.7008 22.7643C18.8545 24.1855 20.0709 25.2933 21.4128 26.1418C21.5842 26.2505 21.7597 26.3383 21.9269 26.4219C22.0774 26.4972 22.2196 26.5682 22.3408 26.6435C22.3575 26.6518 22.3742 26.6644 22.3909 26.6727C22.5331 26.7438 22.6668 26.7772 22.8048 26.7772C23.1517 26.7772 23.3691 26.5599 23.4402 26.4888L24.8698 25.0592C25.0119 24.9171 25.2377 24.7457 25.501 24.7457C25.7602 24.7457 25.9734 24.9087 26.103 25.0508C26.1071 25.055 26.1071 25.055 26.1113 25.0592L28.4146 27.3625C28.8452 27.7888 28.8452 28.2278 28.4188 28.6709Z"
                            fill="white"
                          />
                          <path
                            d="M21.9728 16.7113C23.068 16.8953 24.0629 17.4136 24.8571 18.2078C25.6514 19.0021 26.1655 19.997 26.3537 21.0922C26.3996 21.3681 26.6379 21.5604 26.9096 21.5604C26.9431 21.5604 26.9723 21.5562 27.0058 21.552C27.3151 21.5018 27.5199 21.2092 27.4698 20.8999C27.244 19.5748 26.617 18.3667 25.6597 17.4094C24.7025 16.4522 23.4944 15.8251 22.1693 15.5994C21.8599 15.5492 21.5715 15.7541 21.5172 16.0592C21.4628 16.3644 21.6635 16.6612 21.9728 16.7113Z"
                            fill="white"
                          />
                          <path
                            d="M31.0522 20.7369C30.6801 18.5548 29.6518 16.5692 28.0717 14.9891C26.4916 13.409 24.506 12.3807 22.3239 12.0086C22.0188 11.9543 21.7304 12.1633 21.676 12.4684C21.6258 12.7778 21.8307 13.0662 22.14 13.1205C24.088 13.4508 25.8646 14.3746 27.2775 15.7833C28.6904 17.1962 29.61 18.9728 29.9402 20.9208C29.9862 21.1967 30.2245 21.389 30.4962 21.389C30.5297 21.389 30.5589 21.3848 30.5924 21.3806C30.8975 21.3346 31.1065 21.042 31.0522 20.7369Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_11_577">
                            <rect
                              width="19.806"
                              height="19.806"
                              fill="white"
                              transform="translate(11.2695 12)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </Container>
      </header>
    </>
  );
}

export default LandingHeader;
